import { Component, OnInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { LsFileUploadService } from '../ls-file-upload.service';
import * as $ from 'jquery';
import { LsSnackbarService } from '../../ls-snackbar/ls-snackbar.service';

/**
 * File upload component
 */
@Component({
  selector: 'ls-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
})
export class FileUploadComponent implements OnInit {
  /**
   * data check input
   */
  @Input('checkData') checkData
  /**
   * The constructor
   * @param element 
   */
  public constructor(private element: ElementRef,private snackBar:LsSnackbarService) { }

  allowExtensions = ['pdf', 'odt', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png'];
  blockExtensions = ['.jar', '.war', '.zip', '.rar', '.exe', '.tar', '.7z', '.iso', '.php', '.swf', '.html', '.js',]
  /**
   * message to be displayed
   */
  message;
  /**
   * Drag variable
   */
  drag = true;
  /**
   * return the file
   */
  getFile;
  /**
   * Drop width of file uploader
   */
  @Input("dropWidth") width
  /**
   * Drop height of file uploader
   */
  @Input("dropHeight") height
  /**
   * response of the file upload
   */
  @Input("response") response;
  /**
   * files to be uploaded
   */
  @Output("files") files = new EventEmitter();
  /**
   * uploader type
   */
  @Input('customUploader') customUploader
  /**
   * allow multiple file upload
   */
  @Input("multiple") multiple;
  /**
   * type of the file
   * @example pdf, docx etc
   */
  @Input() fileType: string;
  /**
   * file upload boarder
   */
  @Input() border_not_required: boolean;
  /**
   * current selected file
   */
  selectedFiles;
  /**
   * list of files
   */
  fileList;

  @Input('fileName') fileName: string
  @Input("disabled") disabled;
  @Input('icon') iconName: string = '';
  @Input('errorMsg') errorMsg = '';
  @Input('sizeLimit') sizelimit: number


  propagateChange: any = () => { };
  /**
   * @ignore
   */
  propagateTouch: any = () => { };
  /**



 
  /**
   * @ignore
   */
  ngOnInit() {

  }
  /**
   * On file upload click
   */
  onClick() {

    if (this.customUploader == 4 && this.fileName) {
      this.fileName = undefined
      this.files.emit(null)
      // this.element.nativeElement.querySelector("#lsfileupload").click();
      // this.element.nativeElement.querySelector('#lsfileupload').files = null 
      // this.element.nativeElement.querySelector('#lsfileupload').value = null
    }
    else
    {
      this.fileName = undefined
    this.element.nativeElement.querySelector("#lsfileupload").click();
    }

  }
  /**
   * upload a file 
   */
  upload() {
    let files;
    let filename = [];
    if (this.customUploader == 3)
      files = this.fileList;
    else
      files = this.element.nativeElement.querySelector('#lsfileupload').files;
    // console.log(files[0],'uplosf');

    for(let i = 0;i<files.length;i++){
      filename.push(files[i].name);
      if(this.customUploader==4){
        this.propagateTouch()
      }
    }
  if(this.customUploader==4){
    this.fileUploaderNew(files)
  }
  else{

    this.acceptedFiles(files[0]).then((resp) => { 
      if (resp && resp == 'valid') {
        this.files.emit(files);
        this.fileName = files[0].name;
        $('#lsfileupload').prop('value', '')
        
      }else{
        this.snackBar.open('Invalid File Extension','',2000);
      }     
    })
    
  }
  }


fileUploaderNew(files){
  if (!this.multiple) {

    if (this.sizelimit && (files[0].size > this.sizelimit)) {
      this.errorMsg = "Document size exceeded."
      setTimeout(() => {
        this.errorMsg = ''
      }, 5000);
    }
    else {
      this.acceptedFiles(files[0]).then((msg: any) => {
        if (msg && msg == 'valid') {
          this.files.emit(files[0])
          this.fileName = files[0].name;
          this.propagateChange(files[0]);
        } else {
          this.errorMsg = msg
          setTimeout(() => {
            this.errorMsg = ''
          }, 5000);
        }
      })

    }
  }
  else {
    this.propagateChange(files);
    this.files.emit(files)
    this.fileName = files[0].name;
  }
}

  /**
   * upload file on drag
   * @param value 
   */
  uploadDragFiles(value) {
    this.fileList = value;
    this.upload();
  }


// Block malicious files

  /**
     * blocks the not allowed extensions
     * @param fileName 
     */
    acceptedFiles(file: File) {
      return new Promise((resolve, reject) => {
        let isFileValid = false;
        if (file.name.split('.').length > 2) {
          return 'File Name is Invalid'
        }
        for (let i = 0; i < this.allowExtensions.length; i++) {
          if (file.name.split('.')[1] == this.allowExtensions[i] || file.type.includes(this.allowExtensions[i])) {
            // console.log("first", this.allowExtensions[i]);
            isFileValid = true;
            break;
          }
        }
        if (isFileValid) {
          this.internalFileValid(file).then((resp: any) => {
            if (resp) {
              resolve('valid');
            }
          }, err => {
            resolve("Unsupported File Type.");
          })
  
        } else {
          resolve("Unsupported File Type.");
        }
  
      })
    }
  
  
    internalFileValid(file) {
      return new Promise((resolve, reject) => {
        let blob: File = file
        let header = '';
        let fileReader = new FileReader
  
        fileReader.onloadend = () => {
          let arr = new Uint8Array(fileReader.result as Iterable<any>).subarray(0, 12);
          for (let i = 0; i < arr.length; i++) {
            header += arr[i].toString(16);
          }
          let buffer = header.toLowerCase();
          console.log("complete header string", buffer);
  
          // pdf, png, jpg/jpeg, doc/xls, docx/xlsx~jar~zip
          // || buffer.substring(0, 8) == '504b0304'
          if (buffer.substring(0, 8) == '25504446' || buffer.substring(0, 8) == '89504e47' ||
            buffer.substring(0, 4) == 'ffd8' || buffer.substring(0, 16) == 'd0cf11e0a1b11ae1' || buffer.substring(0,5) == '504b3'  ) {
            resolve(true);
          } else {
            reject(false)
          }
         //exe
          // if (buffer.substring(0, 4) == '5A4D' || buffer.substring(0, 4) == '4D5A') {
          //   reject(false)
          // } else {
          //   resolve(true);
          // }
        }
        fileReader.readAsArrayBuffer(blob)
      })
    }





}


